import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';
import { t } from 'src/utils/translate';

import Page from 'components/Page';
import BannerImage from 'components/BannerImage';
import ScrollAnimation from 'components/ScrollAnimation';
import ContentBlockFull from 'components/ContentBlockFull';
import ContentBlock from 'components/ContentBlock';
import ColumnTwo from 'components/ColumnTwo';
import Container from 'components/Container';
import Spacing from 'components/Spacing';
import Sitemap from './elements/Sitemap';

class Amenities extends Component {
  state = {};
  render() {
    return (
      <Page
        background={require('src/assets/images/amenities/banner.jpg')}
        banner={<BannerImage />}
      >
        <ScrollAnimation>
          <ContentBlockFull
            center={true}
            title={
              <span>
                {t('amenities.title')}
              </span>
            }
            subtitle={t('amenities.subtitle')}
          >
            <Container>
              <p>
                {t('amenities.copy')}
              </p>
            </Container>
          </ContentBlockFull>
        </ScrollAnimation>

        <ScrollAnimation>
          <ColumnTwo
            left={
              <LoungeImg>
                <img
                  src={require('src/assets/images/amenities/lounge.jpg')}
                  alt=""
                />
                <span>{t('amenities.sections.0.title')}</span>
              </LoungeImg>
            }
            right={
              <ContentBlock
                title={
                  <span>
                    {t('amenities.sections.0.title')}
                  </span>
                }
                subtitle={t('amenities.sections.0.subtitle')}
              >
                <Spacing value="120px" md="48px" />
                <p>
                  {t('amenities.sections.0.copy')}
                </p>
              </ContentBlock>
            }
          />
        </ScrollAnimation>
        <ScrollAnimation>
          <Sitemap />
        </ScrollAnimation>
      </Page>
    );
  }
}

const LoungeImg = styled.div`
  position: relative;
  height: 100%;
  img {
    max-width: 100%;
  }
  @media (max-width: ${media.md}) {
    display: block;
    margin: 0 auto;
    float: none;
    img {
      width: 100%;
    }
  }
  span {
    position: absolute;
    left: 15px;
    bottom: 15px;
    color: #fff;
    font-size: 11px;
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.font};
  }
`;

export default Amenities;



// WEBPACK FOOTER //
// ./src/pages/Amenities/Amenities.js